// MOVIE API TYPES
export const FETCH_API_START = 'FETCH_API_START';
export const FETCH_API_SUCCESS = 'FETCH_API_SUCCESS';
export const FETCH_API_FAILURE = 'FETCH_API_FAILURE';

// FAVOURITE TYPES
export const FETCH_FAVOURITES_START = 'FETCH_FAVOURITES_START';
export const FETCH_FAVOURITES_SUCCESS = 'FETCH_FAVOURITES_SUCCESS';
export const FETCH_FAVOURITES_FAILURE = 'FETCH_FAVOURITES_FAILURE';

// RATING TYPES
export const RATING_MOVIE_API_START = 'RATING_MOVIE_API_START';
export const RATING_MOVIE_API_SUCCESS = 'RATING_MOVIE_API_SUCCESS';
export const RATING_MOVIE_API_FAILURE = 'RATING_MOVIE_API_FAILURE';

// RECOMMEND TYPES
export const RECOMMEND_MOVIE_API_START = 'RECOMMEND_MOVIE_API_START';
export const RECOMMEND_MOVIE_API_SUCCESS = 'RECOMMEND_MOVIE_API_SUCCESS';
export const RECOMMEND_MOVIE_API_FAILURE = 'RECOMMEND_MOVIE_API_FAILURE';

// MOVIE CREDIT TYPES
export const MOVIE_CREDITS_API_START = 'MOVIE_CREDITS_API_START';
export const MOVIE_CREDITS_API_SUCCESS = 'MOVIE_CREDITS_API_SUCCESS';
export const MOVIE_CREDITS_API_FAILURE = 'MOVIE_CREDITS_API_FAILURE';

// GUEST SESSION AUTHENTICATION TYPES
export const GUEST_AUTH_API_START = 'GUEST_AUTH_API_START';
export const GUEST_AUTH_API_SUCCESS = 'GUEST_AUTH_API_SUCCESS';
export const GUEST_AUTH_API_FAILURE = 'GUEST_AUTH_API_FAILURE';

// MOVIE GENRE TYPES
export const GENRE_API_START = 'GENRE_API_START';
export const GENRE_API_SUCCESS = 'GENRE_API_SUCCESS';
export const GENRE_API_FAILURE = 'GENRE_API_FAILURE';
